import React from 'react';
import { withStyles, Grid, Dialog, CircularProgress, Paper } from '@material-ui/core';
import TransportColliForm from '../TransportColli/TransportColliForm'
import * as Yup from "yup";
import ExternalSystemSettingTable from '../../sc-externalTable';
import moment from 'moment';
import { hasPermission } from '../../sc-utilities';
import QRCode from 'qrcode.react';
import '../../sc-product/qrCode.scss';
import { snackActions } from '../../sc-utilities/SnackBar';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: '100%',
        height: 'auto',
        padding: 0,
        margin: 0,
    },
    inputs: {
        width: '100%'
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },

    logo: {
        width: '250px',
        margin: '10px'
    },
    qrCode: {
        float: 'left',
        marginRight: "0.5%",
    },
});

const TransportColliDetails = props => {
    const { palette, loadingTransport, classes, onEditPalette, onUnpairedExternal, onUnpairedBulkExternal, activeCustomerID, orders, loading, translations, permissions, activeExternalServiceAvailable, groups } = props;
    let initialValues = {
        Name: palette && palette.Name ? palette.Name : '',
        Description: palette && palette.Description ? palette.Description : '',
        Location: palette && palette.Location ? palette.Location : '',
        Order: palette && palette.OrderID ? String(palette.OrderID) : '',
        ArrivedDate: palette && palette.ArrivedDate ? moment(palette.ArrivedDate) : '',
        GroupID: palette?.GroupID ?? 'n/a'
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Description: Yup.string().required("Required"),
            Location: Yup.string().required("Required"),
            Order: Yup.string().required("Required"),
            ArrivedDate: Yup.date().required("Required")
        },
        FormTitle: translations['edit_transport_colli'] || "Edit transport colli",
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        },
    };

    const handleSubmit = async data => {
        if (data["Order"] === "") {
            snackActions.snackBarComponent("Order is required for editing Transport Colli.", "info");
            return;
        }
        if (data["GroupID"] === "n/a") {
            data["GroupID"] = null;
        }
        data['TransportColliID'] = palette.TransportColliID;
        await onEditPalette({ ...data, ActiveCustomerID: activeCustomerID });
    }

    return (
        <>
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={!loading}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            <div className="tooltip">
                <QRCode
                    size={50}
                    className={classes.qrCode}
                    value={`<TransportColli>${palette.TransportColliID}</TransportColli>`}
                />
                <span>
                    <QRCode
                        size={200}
                        value={`<TransportColli>${palette.TransportColliID}</TransportColli>`}
                    />
                </span>
            </div>
            <Grid container className={classes.root} spacing={1}>
                <Grid item xs={hasPermission(permissions, 'palette_external_info_view') && activeExternalServiceAvailable ? 6 : 12}>
                    {!loadingTransport ?
                        <Paper>
                            <TransportColliForm
                                formSettings={formSettings}
                                initialValues={initialValues}
                                handleSubmit={handleSubmit}
                                orders={orders}
                                loading={loadingTransport}
                                translations={translations}
                                groups={groups}

                            /></Paper> : <CircularProgress size={50} />}
                </Grid>
                {hasPermission(permissions, 'palette_external_info_view') && activeExternalServiceAvailable ?
                    <Grid item xs={6}>
                        <ExternalSystemSettingTable onUnpairedExternal={onUnpairedExternal} type={translations['transport_colli'] || "Transport Colli"} onUnpairedBulkExternal={onUnpairedBulkExternal} data={palette && palette.PaletteExternalInfo ? palette.PaletteExternalInfo : []} />
                    </Grid>
                    : null}
            </Grid>
        </>
    )
}
export default withStyles(styles, { withTheme: true })(TransportColliDetails);
